import generateShortId from '@/utils/generateId.js'

export const generateProduct = () => {
  return {
    id: '', // 产品 id
    demand_id: '', // 需求 id
    package_name: '', // 包名
    offer_uuid: '', // offer uuid
    mtg_daily_cost: '', // mtg 日均消耗
    app_id: '', // app id
    app_url: '', // app url
    app_name: '', // app 名称
    platform: '', // 平台

    // 前端自己用的属性
    _id: generateShortId(), // 前端生成的 id，因为新创建需求时时没有产品 id 的
    title: '' // el-card 的 title
  }
}
